<template>
  <div id="detail" class="detail">
    <!-- <div class="back" @click="back"><img src="./img/backup.png" alt=""><span>返回上一页</span></div> -->
    <div style="display: flex;align-items: center;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">姓名</div>
      <input  style="background-color: #ffffff" type="text"  v-model="userName" placeholder="请输入姓名" >
    </div>

    <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">身份证号</div>
      <input  style="background-color: #ffffff" type="text"  v-model="idNo" placeholder="请输入身份证号" >
    </div>
     <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">联系电话</div>
      <input  style="background-color: #ffffff" type="text"  v-model="userPhone" placeholder="请输入联系电话" >
    </div>
    <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">期望就诊医院</div>
      <input  style="background-color: #ffffff" type="text"  v-model="expectHospital" placeholder="请输入期望就诊医院" >
    </div>
    <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 30vw;" :style="{fontSize: $px2rem(14)}">期望就诊时间</div>
      <el-date-picker
      v-model="expectDate1"
      type="date"
      :editable="false"
      placeholder="选择日期">
    </el-date-picker>
    <span>-</span>
    <el-date-picker
      v-model="expectDate2"
      type="date"
      :editable="false"
      placeholder="选择日期">
    </el-date-picker>
    </div>
    <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">期望科室</div>
      <input  style="background-color: #ffffff" type="text"  v-model="expectKeShi" placeholder="请输入期望科室" >
    </div>
    <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">报销方式</div>
      <input  style="background-color: #ffffff" type="text"  v-model="baoXiaoMethod" placeholder="请输入报销方式" >
    </div>
     <div style="display: flex;align-items: center;margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">病情描述和诊断</div>
      <input  style="background-color: #ffffff" type="text"  v-model="diseaseDescription" placeholder="请输入病情描述和诊断" >
    </div>
    <div style="margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">诊断报告</div>
    
      <div v-for="(v, i) in array" :key="i" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;position: relative;margin-left:1px">
        <img style="width: 100%;height:100%;" :src="v.url">
      </div>
      <div style="height: 21vw;display:inline-block" v-if="this.array.length != 0 && this.array.length != 3 && this.array.length != 6">
        <div v-if="this.array.length != 9" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;    position: absolute;" @click="report()">
        <img style="width: 10vw;position: absolute;left: 50%;margin-left: -5vw;top: 50%;margin-top: -5vw;" src="@/assets/serviceImg/tj.png">
        </div>
      </div>
      <div style="height: 31vw;display:inline-block" v-else>
        <div v-if="this.array.length != 9" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;    position: relative;" @click="report()">
        <img style="width: 10vw;position: absolute;left: 50%;margin-left: -5vw;top: 50%;margin-top: -5vw;" src="@/assets/serviceImg/tj.png">
        </div>
      </div>
    </div>
    <div style="margin-top: 4vw;">
      <div style="width: 35vw;" :style="{fontSize: $px2rem(14)}">其他医学材料</div>
      <div  v-for="(v, i) in array1" :key="i" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;position: relative;margin-left:1px">
        <img style="width: 100%;height:100%;" :src="v.url">
      </div>
      <div style="height: 21vw;display:inline-block" v-if="this.array1.length != 0 && this.array1.length != 3 && this.array1.length != 6">
        <div v-if="this.array1.length != 9" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;    position: absolute;" @click="report1()">
        <img style="width: 10vw;position: absolute;left: 50%;margin-left: -5vw;top: 50%;margin-top: -5vw;" src="@/assets/serviceImg/tj.png">
      </div>
    </div>
    <div style="height: 31vw;display:inline-block" v-else>
        <div v-if="this.array1.length != 9" style="display: inline-block;border-radius: 4px;border: 1px solid rgb(225, 225, 225);width: 30vw;height: 30vw;background-color: #ffffff;margin-top: 3vw;text-align: center;    position: relative;" @click="report1()">
        <img style="width: 10vw;position: absolute;left: 50%;margin-left: -5vw;top: 50%;margin-top: -5vw;" src="@/assets/serviceImg/tj.png">
        </div>
      </div>
    </div>
    <div style="width:100%;height: 40px;background: rgb(0, 187, 130);border-radius: 20px;text-align: center;line-height: 40px;color: #ffffff;margin-top: 10vw;"  @click="Submit()">提交</div>
  </div>
</template>
<script>
import Axios from 'axios'
import { assistsendemail } from '@/api/activity'
// import picker from './picker.vue'
export default {
  data () {
    return {
      expectDate1:'',//开始时间
      expectDate2:'',//结束时间
      baoXiaoMethod:'',//报销方式
      diagnosticReportIds:[],//诊断报告图片地址 id逗号拼接
      diseaseDescription:'',//病情描述和诊断（针对没检查资料客户补充提供)
      expectDate:'',//期望就诊时间段 请填写至少包含 5 个工作日的一个时间段，传参示例：2024.5.28-6.4）
      expectHospital:'',//期望就诊医院
      expectKeShi	:'',//期待科室
      idNo:'',//身份证号
      otherMaterialIds:[],//其他医学资料 id逗号拼接
      userName	:'',//姓名
      userPhone	:'',//联系电话
      tiemces:'',
      value1:'',
      value2:'',
      attribute:'',
      src1:'',
      detailText: '',
      maxCount:9,
      maxCount1:9,
      array:[],
      array1:[],
      ImgType:1,
    };
  },
  // components:{ picker},
  created(){
  },
  beforeCreate() {
    document.title = "门诊协助预约"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  mounted() {
    window.uploadImageResult = this.uploadImageResult
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "48px";
        }
  },
  methods: {
    Submit() {
      console.log(this.convertToLocalTime(this.expectDate1))
      console.log(this.convertToLocalTime(this.expectDate2))
      this.expectDate = this.convertToLocalTime(this.expectDate1) + '-' + this.convertToLocalTime(this.expectDate2)

      for(var i = 0; i<this.array.length; i++) {
        this.diagnosticReportIds.push(this.array[i].id)
      }
      for(var i = 0; i<this.array1.length; i++) {
        this.otherMaterialIds.push(this.array1[i].id)
      }
  
      var obj = {
        baoXiaoMethod:this.baoXiaoMethod,//报销方式
        diagnosticReportIds:this.diagnosticReportIds.join(","),//诊断报告图片地址 id逗号拼接
        diseaseDescription:this.diseaseDescription,//病情描述和诊断（针对没检查资料客户补充提供)
        expectDate:this.expectDate,//期望就诊时间段 请填写至少包含 5 个工作日的一个时间段，传参示例：2024.5.28-6.4）
        expectHospital:this.expectHospital,//期望就诊医院
        expectKeShi:this.expectKeShi,//期待科室
        idNo:this.idNo,//身份证号
        otherMaterialIds:this.otherMaterialIds.join(","),//其他医学资料 id逗号拼接
        userName:this.userName,//姓名
        userPhone:this.userPhone,//联系电话
      }
    
      assistsendemail(obj).then((res)=>{
        if(res.data == 1000) {
          this.$message({
              showClose: true,
              message: '提交成功',
              type: 'success',
              center: true,
              offset: 200,
              duration: 2000,
              customClass: 'widthMessage'
            })
            window.location.href = 'appdjxhealth://actionFinishWebview'
        }
     
      
        console.log(res)
      })
    },
    convertToLocalTime(utcTime) {
    const localTime = new Date(utcTime.getTime() + 8 * 60 * 60 * 1000);
    const year = localTime.getFullYear();
    const month = (localTime.getMonth() + 1).toString().padStart(2, '0');
    const day = localTime.getDate().toString().padStart(2, '0');
    const hours = localTime.getHours().toString().padStart(2, '0');
    const minutes = localTime.getMinutes().toString().padStart(2, '0');
    const seconds = localTime.getSeconds().toString().padStart(2, '0');
    return `${year}.${month}.${day} `;
},
    report1() {
      this.ImgType = 2
      var maxCount = this.maxCount1 - this.array1.length
      window.location.href =
        'appdjxhealth://actionUpdateImage?maxCount=' + maxCount
    },
    report() {
      this.ImgType = 1
      var maxCount =  this.maxCount - this.array.length
      window.location.href =
        'appdjxhealth://actionUpdateImage?maxCount=' + maxCount
    },
    uploadImageResult(item) {
      // alert('11111111111')
      // return '上传成功'
      // this.tiemces = item
      // var item = '[{"id":"1802982389102809088","index":1,"url":"http://thealth.dajiuxing.com.cn/health/api/upload/f78f1f0b-e2ae-4fb8-ae56-8f713fd51b6e.jpg"},{"id":"1802982389102809088","index":1,"url":"http://thealth.dajiuxing.com.cn/health/api/upload/f78f1f0b-e2ae-4fb8-ae56-8f713fd51b6e.jpg"},{"id":"1802982389102809088","index":1,"url":"http://thealth.dajiuxing.com.cn/health/api/upload/f78f1f0b-e2ae-4fb8-ae56-8f713fd51b6e.jpg"},{"id":"1802982389459324928","index":2,"url":"http://thealth.dajiuxing.com.cn/health/api/upload/aca6db8d-e60f-4b6d-bfb4-33dbe4f220fc.jpg"}]'
      if( this.ImgType == 1) {
        console.log(JSON.parse(item))
        for(var i = 0; i<JSON.parse(item).length; i++) {
          this.array.push(JSON.parse(item)[i])
        }
      
      }else {
        for(var i = 0; i<JSON.parse(item).length; i++) {
          this.array1.push(JSON.parse(item)[i])
        }
        // this.array1 = item.split(",");
      }
    }, 
    getDate(obj){
            console.log(obj)
        },
    // detail(){
    //   Axios({
    //     params:{
    //       id:this.$route.query.id
    //     },
    //     // util.config.api
    //     methods:'post',
    //     baseURL: 'https://api.dajiuxing.com.cn',
    //     url: '/1.0/news/news-info'
    //   }).then(res=>{
    //     console.log(res,'详情详情');
    //     this.detailText = res.data.obj;
    //     this.attribute = res.data.obj.attribute
    //     if(res.data.obj.attribute == 3) {
    //       this.src1 = res.data.obj.url
    //     }else {
    //       this.src1 = res.data.obj.pic
    //     }
       
    //   }).catch(error=>{
    //     console.log(error)
    //   })
    // },
    
  }
}
</script>
<style scoped >
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:31vw
}
/deep/ .el-date-range-picker {
  width: 100% !important;
  left: 0 !important;
}
/deep/ .el-date-editor .el-range-separator {
  width:auto
}
/deep/ .el-input__inner {
  padding-right: 0px !important;
}
/deep/ .el-input__icon {
  width:6vw !important;
}
input {

  font-size: 4vw;
  border-radius: 4px;
  padding-left: 3vw;
  width: 71vw;
    height: 40px;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    /* font-size: inherit; */
    line-height: 40px;
    outline: none;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1)
}
  .title{
    line-height: 2rem;
    text-align: center;
    margin: 1rem 0;
    border-bottom: none;
    padding: 0;
  }
  h5{
    /* font-size: 1.04166vw; */
    font-weight: normal;
    margin-bottom: 1.04166vw;
  }   
  .rich_text {
    text-indent: 2em;
    width:100%;
    word-wrap: break-word;
  }
  .rich_text >>> img{
    width: 100%;
  }
  .back{
    cursor: pointer;
    margin-bottom: 1.04166vw;
  }
  img{
    width: 1.145833vw;
    /* height: 0.98958333vw; */
    vertical-align: middle;
    margin-right: .5vw;
    margin-bottom: 1rem;
  }
  .rich_text, .rich_text span, .rich_text p, .rich_text strong{
    font-size: 0.95rem!important;
    color: #666!important;
    line-height: 1.5rem!important;
  }
  .detail{
    padding: 1rem 1rem 2rem;
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/views/detailsH5/makeanappointment.vue